import { render, staticRenderFns } from "./SingleResult.vue?vue&type=template&id=fa4472f4&scoped=true&"
import script from "./SingleResult.vue?vue&type=script&lang=js&"
export * from "./SingleResult.vue?vue&type=script&lang=js&"
import style0 from "./SingleResult.vue?vue&type=style&index=0&id=fa4472f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4472f4",
  null
  
)

export default component.exports